import { useEffect, useMemo, useState } from "react";
import { evaluate } from "@mdx-js/mdx";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

function isExternalHref(href) {
  return typeof href === "string" && /^https?:\/\//i.test(href);
}

function LinkRenderer(props) {
  const { href, children, ...rest } = props;
  if (isExternalHref(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}

const DEFAULT_COMPONENTS = {
  a: LinkRenderer,
};

function MdxRenderer({ source, className = "", components = {} }) {
  const [Content, setContent] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const mergedComponents = useMemo(
    () => ({
      ...DEFAULT_COMPONENTS,
      ...components,
    }),
    [components]
  );

  useEffect(() => {
    let isCancelled = false;

    async function compileMdx() {
      setContent(null);
      setErrorMessage("");

      try {
        const evaluatedModule = await evaluate(source, {
          Fragment,
          jsx,
          jsxs,
          useDynamicImport: false,
        });

        if (!isCancelled) {
          setContent(() => evaluatedModule.default);
        }
      } catch (error) {
        console.error("[MdxRenderer] Failed to compile MDX:", error);
        if (!isCancelled) {
          setErrorMessage(
            "We could not render this article right now. Please refresh and try again."
          );
        }
      }
    }

    if (source) {
      compileMdx();
    }

    return () => {
      isCancelled = true;
    };
  }, [source]);

  if (errorMessage) {
    return <p className="blog-post__render-error">{errorMessage}</p>;
  }

  if (!Content) {
    return <p className="blog-post__loading">Loading article...</p>;
  }

  return (
    <div className={className}>
      <Content components={mergedComponents} />
    </div>
  );
}

export default MdxRenderer;

